import Vue from "vue";

export const status = {
    namespaced: true,
    state: {
        builder: {
            mode: "plano",
            svg: null,
            modules: [],
            modulesSvg: [],
            groups: [],
            groupsElt: [],
            pan: false,
            selection: true,
            positionModule: [],
            idModule: "",
            selectModules: [],
            viewsActive: ["ref", "highlights"],
            groupSelected: null,
            moduleConf: [],
            scratchModule: [],
            favModules: [],
            zoommodule: false,
            xmlSvg: "",
            modulesEdit: null,
            modifiedUser: {},
            accessories: [],
            accessoriesSelected: [],
            displayMode: "iconscolors",
            displayMenuShades: false,
            displayMenuTicketStrip: false,
            displayMenuScratch: false,
            displayMenuFavorite: false,
            displayMenuLibrary: false,
            displayComments: false,
            displayExports: false,
            modeSave: false,
            showModalFav: false,
            updatePlano: false,
            ticketStripClone: null,
            activeLayer: false,
            posMenuLayer: { x: 0, y: 0 },
            overHang: false,
            snapMod: false,
            freePosition: false
        }
    },
    getters: {
        isActiveLayer(state) {
            return state.builder.activeLayer;
        },

        getPosMenuLayer(state) {
            return state.builder.posMenuLayer;
        },

        hasUpdatePlano(state) {
            return state.builder.updatePlano;
        },
        getViewsActive(state) {
            return state.builder.viewsActive;
        },
        showModalFavorite(state) {
            return state.builder.showModalFav;
        },
        canModeSave(state) {
            return state.builder.modeSave;
        },
        canDisplayComments(state) {
            return state.builder.displayComments;
        },
        canDisplayExports(state) {
            return state.builder.displayExports;
        },
        canDisplayMenuLibrary(state) {
            return state.builder.displayMenuLibrary;
        },
        canDisplayMenuFavorite(state) {
            return state.builder.displayMenuFavorite;
        },
        canDisplayMenuScratch(state) {
            return state.builder.displayMenuScratch;
        },
        canDisplayMenuShades(state) {
            return state.builder.displayMenuShades;
        },
        canDisplayMenuTicketStrip(state) {
            return state.builder.displayMenuTicketStrip;
        },
        getMode(state) {
            return state.builder.mode;
        },
        getAccessories(state) {
            return state.builder.accessories;
        },
        getAccessoriesSelected(state) {
            return state.builder.accessoriesSelected;
        },
        getModulesEdit: state => {
            return state.builder.modulesEdit;
        },
        getFavModule: state => {
            return state.builder.favModules;
        },
        getScratchPad: state => {
            return state.builder.scratchModule;
        },
        getPositionModule: state => {
            return state.builder.positionModule;
        },
        getModuleConf: state => {
            return state.builder.moduleConf;
        },
        getSvg: (state, getters) => {
            return state.builder.svg;
        },
        getModulesSvg: (state, getters) => {
            return state.builder.modulesSvg;
        },
        getModules: (state, getters) => {
            return state.builder.modules;
        },
        getXmlSvg: (state, getters) => key => {
            if (typeof key !== "undefined") {
                return state.builder.xmlSvg[key];
            } else {
                return state.builder.xmlSvg;
            }
        },
        getGroups: (state, getters) => key => {
            if (typeof key !== "undefined") {
                return state.builder.groups[key];
            } else {
                return state.builder.groups;
            }
        },
        getGroupsElt: (state, getters) => key => {
            if (typeof key !== "undefined") {
                return state.builder.groupsElt[key];
            } else {
                return state.builder.groupsElt;
            }
        },
        getSvgDimensions: (state, getters) => {
            return state.builder.svgDimensions;
        },
        getPan(state) {
            return state.builder.pan;
        },
        isPan(state) {
            return state.builder.pan;
        },
        getSelection(state) {
            return state.builder.selection;
        },
        getZoomModule(state) {
            return state.builder.zoommodule;
        },
        /**
         *
         * @param state
         * @returns {Array} returne les elements mmdule (svg) selectionner
         */
        getSelectModules(state) {
            return state.builder.selectModules;
        },
        countSelectModules(state) {
            return state.builder.selectModules.length;
        },
        getGroupSelected(state) {
            return state.builder.groupSelected;
        },
        getDisplayMode(state) {
            return state.builder.displayMode;
        },
        getTicketStripClone(state) {
            return state.builder.ticketStripClone;
        },

        hasOverHang(state) {
            return state.builder.overHang;
        },

        hasSnapMod(state) {
            return state.builder.snapMod;
        },

        isFreePosition(state) {
            return state.builder.freePosition;
        }
    },
    mutations: {
        groups: function(state, data) {
            return state.builder.groupsElt.push(data);
        },
        updateBuilder: function(state, { field, value }) {
            Object.assign(state.builder, { [field]: value });
        },
        fakeCatalog: function(state, list) {
            Vue._.forEach(list, function(value, key) {});
        },
        SET_XML_SVG: function(state, data) {
            state.builder.xmlSvg = data;
        },

        ADD_SELECT_MODULE(state, data) {
            state.builder.selectModules.push(data);
        },

        DELETE_SELECT_MODULE(state, data) {
            let modules = state.builder.selectModules;

            if (modules.includes(data)) {
                modules.splice(modules.indexOf(data), 1);
            }
        },

        DELETE_ALL_MODULES(state) {
            let modules = state.builder.selectModules;
            modules.splice(0, modules.length);
        },

        DELETE_ALL_MODULES_ELT(state) {
            let modules = state.builder.modules;
            modules.splice(0, modules.length);
        },

        DELETE_GROUP(state, group) {
            let groups = state.builder.groups;
            if (groups.includes(group)) {
                groups.splice(groups.indexOf(group), 1);
            }
        },

        SAVE_GROUP(state, group) {
            state.builder.groups.push(group);
        },

        GROUP_SELECTED(state, group) {
            state.builder.groupSelected = group;
        },

        ADD_MODULE(state, module) {
            state.builder.modules.push(module);
        },

        DELETE_MODULE(state, module) {
            let modules = state.builder.modules;
            if (modules.includes(module)) {
                modules.splice(modules.indexOf(module), 1);
            }
        },

        MODULES_EDIT(state, modules) {
            state.builder.modulesEdit = modules;
        },

        DELETE_SCRATCHPAD(state, object) {
            let scratchpads = state.builder.scratchModule;
            if (scratchpads.includes(object)) {
                scratchpads.splice(scratchpads.indexOf(object), 1);
            }
        },
        ADD_SCRATCHPAD(state, object) {
            state.builder.scratchModule.push(object);
        },
        ADD_FAVORITE(state, object) {
            state.builder.favModules.push(object);
        },
        ADD_ACCESSORY(state, object) {
            state.builder.accessories.push(object);
        },
        DELETE_ACCESSORY(state, object) {
            let accessories = state.builder.accessories;
            if (accessories.includes(object)) {
                accessories.splice(accessories.indexOf(object), 1);
            }
        },
        ADD_SELECTED_ACCESSORY(state, object) {
            state.builder.accessoriesSelected.push(object);
        },
        DELETE_SELECTED_ACCESSORY(state, object) {
            let accessories = state.builder.accessoriesSelected;
            if (accessories.includes(object)) {
                accessories.splice(accessories.indexOf(object), 1);
            }
        },
        SET_MODE(state, mode) {
            state.builder.mode = mode;
        },
        SET_MODE_SAVE(state, mode) {
            state.builder.modeSave = mode;
        },
        SET_SHOW_MODAL_FAV(state, show) {
            state.builder.showModalFav = show;
        },
        SET_DISPLAY_MENUSHADES(state, display) {
            state.builder.displayMenuShades = display;
        },
        SET_DISPLAY_MENU_TICKETSTRIP(state, display) {
            state.builder.displayMenuTicketStrip = display;
        },
        SET_DISPLAY_MENUSCRATCH(state, display) {
            state.builder.displayMenuScratch = display;
        },
        SET_DISPLAY_FAVORITE(state, display) {
            state.builder.displayMenuFavorite = display;
        },
        SET_DISPLAY_LIBRARY(state, display) {
            state.builder.displayMenuLibrary = display;
        },
        SET_DISPLAY_COMMENTS(state, display) {
            state.builder.displayComments = display;
        },

        SET_DISPLAY_EXPORTS(state, display) {
            state.builder.displayExports = display;
        },

        ADD_VIEW_ACTIVE(state, view) {
            if (!state.builder.viewsActive.includes(view)) {
                state.builder.viewsActive.push(view);
            }
        },
        REMOVE_VIEW_ACTIVE(state, view) {
            let views = state.builder.viewsActive;
            if (views.includes(view)) {
                views.splice(views.indexOf(view), 1);
            }
        },
        SET_UPDATE_PLANO(state, update) {
            state.builder.updatePlano = update;
        },
        SET_TICKETSTRIP_CLONE(state, data) {
            state.builder.ticketStripClone = data;
        },

        SET_ACTIVE_LAYER(state, active) {
            state.builder.activeLayer = active;
        },

        SET_POS_MENU_LAYER(state, pos) {
            state.builder.posMenuLayer = pos;
        },

        SET_OVER_OVER_HANG(state, overHang) {
            state.builder.overHang = overHang;
        },

        SET_SNAP_MOD(state, snap) {
            state.builder.snapMod = snap;
        },

        SET_PAN(state, pan) {
            state.builder.pan = pan;
        },

        INIT_VIEWS(state) {
            state.builder.viewsActive = ["ref", "highlights"];
        },

        SET_FREE_POSITION(state, freePosition) {
            state.builder.freePosition = freePosition;
        }
    },
    actions: {
        setTicketStripToClone(context, data) {
            context.commit("SET_TICKETSTRIP_CLONE", data);
        },
        groups: (context, datas) => {
            return new Promise((resolve, reject) => {
                Vue._.forEach(datas, function(data, key) {
                    context.commit("groups", data);
                    resolve(context.state.builder.groupsElt.length - 1);
                });
            });
        },
        setXmlSvg: (context, datas) => {
            return new Promise((resolve, reject) => {
                Vue._.forEach(datas, function(data, key) {
                    context.commit("SET_XML_SVG", data);
                    resolve();
                });
            });
        },
        addSelectModule(context, module) {
            context.commit("ADD_SELECT_MODULE", module);
        },
        deleteSelectModule(context, module) {
            context.commit("DELETE_SELECT_MODULE", module);
        },
        saveGroup(context, group) {
            context.commit("SAVE_GROUP", group);
        },
        deleteAllModules(context) {
            context.commit("DELETE_ALL_MODULES");
        },
        deleteAllModulesElt(context) {
            context.commit("DELETE_ALL_MODULES_ELT");
        },
        setGroupSelected(context, group) {
            context.commit("GROUP_SELECTED", group);
        },
        addModule(context, module) {
            context.commit("ADD_MODULE", module);
        },
        deleteModule(context, module) {
            context.commit("DELETE_MODULE", module);
        },
        deleteGroup(context, group) {
            context.commit("DELETE_GROUP", group);
        },
        setModulesEdit(context, modules) {
            context.commit("MODULES_EDIT", modules);
        },
        deleteScratchModule(context, object) {
            context.commit("DELETE_SCRATCHPAD", object);
        },
        addScratchPad(context, object) {
            context.commit("ADD_SCRATCHPAD", object);
        },
        addAccessory(context, accessory) {
            context.commit("ADD_ACCESSORY", accessory);
        },
        addFavorite(context, object) {
            context.commit("ADD_FAVORITE", object);
        },
        deleteAccessory(context, accessory) {
            context.commit("DELETE_ACCESSORY", accessory);
        },
        addAccessorySelected(context, accessory) {
            context.commit("ADD_SELECTED_ACCESSORY", accessory);
        },
        deleteAccessorySelected(context, accessory) {
            context.commit("DELETE_SELECTED_ACCESSORY", accessory);
        },
        setMode(context, mode) {
            context.commit("SET_MODE", mode);
        },
        setModeSave(context, mode) {
            context.commit("SET_MODE_SAVE", mode);
        },
        setShowModalFavorite(context, show) {
            // context.actions.setDisplayMenuScratch(false)
            // context.actions.setDisplayMenuShades(false)
            context.commit("SET_SHOW_MODAL_FAV", show);
        },
        setDisplayMenuShades(context, display) {
            context.commit("SET_DISPLAY_MENUSCRATCH", false);
            context.commit("SET_DISPLAY_FAVORITE", false);
            context.commit("SET_DISPLAY_LIBRARY", false);
            context.commit("SET_DISPLAY_COMMENTS", false);
            context.commit("SET_DISPLAY_MENU_TICKETSTRIP", false);
            context.commit("SET_DISPLAY_EXPORTS", false);
            context.commit("SET_DISPLAY_MENUSHADES", display);
        },
        closeAllMenus(context) {
            context.commit("SET_DISPLAY_MENUSCRATCH", false);
            context.commit("SET_DISPLAY_FAVORITE", false);
            context.commit("SET_DISPLAY_LIBRARY", false);
            context.commit("SET_DISPLAY_COMMENTS", false);
            context.commit("SET_DISPLAY_MENU_TICKETSTRIP", false);
            context.commit("SET_DISPLAY_EXPORTS", false);
            context.commit("SET_DISPLAY_MENUSHADES", false);
        },
        setDisplayMenuTicketStrip(context, display) {
            context.commit("SET_DISPLAY_MENUSCRATCH", false);
            context.commit("SET_DISPLAY_FAVORITE", false);
            context.commit("SET_DISPLAY_LIBRARY", false);
            context.commit("SET_DISPLAY_COMMENTS", false);
            context.commit("SET_DISPLAY_MENUSHADES", false);
            context.commit("SET_DISPLAY_EXPORTS", false);
            context.commit("SET_DISPLAY_MENU_TICKETSTRIP", display);
        },
        setDisplayMenuScratch(context, display) {
            context.commit("SET_DISPLAY_MENUSHADES", false);
            context.commit("SET_DISPLAY_FAVORITE", false);
            context.commit("SET_DISPLAY_LIBRARY", false);
            context.commit("SET_DISPLAY_COMMENTS", false);
            context.commit("SET_DISPLAY_MENU_TICKETSTRIP", false);
            context.commit("SET_DISPLAY_EXPORTS", false);
            context.commit("SET_DISPLAY_MENUSCRATCH", display);
        },
        setDisplayMenuFavorite(context, display) {
            context.commit("SET_DISPLAY_MENUSHADES", false);
            context.commit("SET_DISPLAY_MENUSCRATCH", false);
            context.commit("SET_DISPLAY_LIBRARY", false);
            context.commit("SET_DISPLAY_COMMENTS", false);
            context.commit("SET_DISPLAY_MENU_TICKETSTRIP", false);
            context.commit("SET_DISPLAY_EXPORTS", false);
            context.commit("SET_DISPLAY_FAVORITE", display);
        },
        setDisplayMenuLibrary(context, display) {
            context.commit("SET_DISPLAY_MENUSHADES", false);
            context.commit("SET_DISPLAY_MENUSCRATCH", false);
            context.commit("SET_DISPLAY_FAVORITE", false);
            context.commit("SET_DISPLAY_COMMENTS", false);
            context.commit("SET_DISPLAY_MENU_TICKETSTRIP", false);
            context.commit("SET_DISPLAY_EXPORTS", false);
            context.commit("SET_DISPLAY_LIBRARY", display);
        },
        setDisplayComments(context, display) {
            context.commit("SET_DISPLAY_MENUSHADES", false);
            context.commit("SET_DISPLAY_MENUSCRATCH", false);
            context.commit("SET_DISPLAY_FAVORITE", false);
            context.commit("SET_DISPLAY_LIBRARY", false);
            context.commit("SET_DISPLAY_MENU_TICKETSTRIP", false);
            context.commit("SET_DISPLAY_EXPORTS", false);
            context.commit("SET_DISPLAY_COMMENTS", display);
        },
        setDisplayExports(context, display) {
            context.commit("SET_DISPLAY_MENUSHADES", false);
            context.commit("SET_DISPLAY_MENUSCRATCH", false);
            context.commit("SET_DISPLAY_FAVORITE", false);
            context.commit("SET_DISPLAY_LIBRARY", false);
            context.commit("SET_DISPLAY_MENU_TICKETSTRIP", false);
            context.commit("SET_DISPLAY_COMMENTS", false);
            context.commit("SET_DISPLAY_EXPORTS", display);
        },
        addViewActive(context, view) {
            context.commit("ADD_VIEW_ACTIVE", view);
        },
        removeViewActive(context, view) {
            context.commit("REMOVE_VIEW_ACTIVE", view);
        },
        setUpdatePlano(context, update) {
            context.commit("SET_UPDATE_PLANO", update);
        },
        setActiveLayer(context, active) {
            context.commit("SET_ACTIVE_LAYER", active);
        },
        setPosMenuLayer(context, pos) {
            context.commit("SET_POS_MENU_LAYER", pos);
        },
        setOverHang(context, overHang) {
            context.commit("SET_OVER_OVER_HANG", overHang);
        },

        setSnapMod(context, snap) {
            context.commit("SET_SNAP_MOD", snap);
        },

        setPan(context, pan) {
            context.commit("SET_PAN", pan);
        },

        initViews(context) {
            context.commit("INIT_VIEWS");
        },

        setFreePosition(context, freePosition) {
            context.commit("SET_FREE_POSITION", freePosition);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/plano/status.js